import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { BaseApiResponse } from '../../models/api/api.model';
import { environment } from '../../../../environments/environment';
import {
  CreateFacilityRequest,
  DeleteFacilityRequest,
  FacilityListData,
  FacilitySimpleData,
  FacilityWithOrganizationData,
  UpdateFacilityRequest,
} from '../../models/organization/facility.model';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  constructor(private apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.organization}/facilities`;

  private getListFacilityURL = `${this.apiURL}/getListFacility`;
  private getFacilityByIdURL = `${this.apiURL}/getFacilityById`;
  private getFacilitiesWithCurrentOrganizationURL = `${this.apiURL}/getFacilitiesWithCurrentOrganization`;
  private getAllFacilitiesByOrganizationURL = `${this.apiURL}/getAllFacilitiesByOrganization`;
  private deleteFacilityURL = `${this.apiURL}/deleteFacility`;
  private updateFacilityURL = `${this.apiURL}/updateFacility`;
  private createFacilityURL = `${this.apiURL}/createFacility`;

  getListFacility(
    pageIndex: number = 0,
    pageSize: number = 10
  ): Observable<BaseApiResponse<FacilityListData>> {
    const url = `${this.getListFacilityURL}?PageIndex=${pageIndex}&PageSize=${pageSize}`;
    return this.apiService.get<FacilityListData>(url);
  }

  getFacilityById(id: string): Observable<BaseApiResponse<FacilityListData>> {
    return this.apiService.get<FacilityListData>(
      `${this.getFacilityByIdURL}?Id=${id}`
    );
  }

  getFacilitiesWithCurrentOrganization(
    organizationId: string,
    organizationName: string
  ): Observable<BaseApiResponse<FacilityWithOrganizationData>> {
    const url = `${this.getFacilitiesWithCurrentOrganizationURL}?OrganizationId=${organizationId}&OrganizationName=${organizationName}`;
    return this.apiService.get<FacilityWithOrganizationData>(url);
  }

  getAllFacilitiesByOrganization(
    organizationId: string
  ): Observable<BaseApiResponse<FacilitySimpleData>> {
    return this.apiService.get<FacilitySimpleData>(
      `${this.getAllFacilitiesByOrganizationURL}?OrganizationId=${organizationId}`
    );
  }

  createFacility(
    request: CreateFacilityRequest
  ): Observable<BaseApiResponse<any>> {
    return this.apiService.post<any>(this.createFacilityURL, request);
  }

  updateFacility(
    request: UpdateFacilityRequest
  ): Observable<BaseApiResponse<any>> {
    return this.apiService.post<any>(this.updateFacilityURL, request);
  }

  deleteFacility(id: string): Observable<BaseApiResponse<any>> {
    const request: DeleteFacilityRequest = { id: id };
    return this.apiService.post<any>(this.deleteFacilityURL, request);
  }
}
